// Logic to handle upsell product addition to cart with Teeinblue form
document.addEventListener('teeinblue-event-component-injected', function () {
  // Query the Teein Form Add to Cart button
  const teeForm = document.getElementById('teeFormActions');
  if (teeForm) {
    // Create your upsell feature element
    const upsellDiv = document.getElementById('upsellProductContainer');
    const teeAtcButton = document.getElementById('teeAtcButton');
    const teeBuyNowButton = document.getElementById('teeBuynowButton');
    const productQuantityInput = document.querySelector('input.tee-quantity-input');
    const upsellCheckbox = document.getElementById('upsellCheckbox');

    // Insert upsell feature below the Teein Form button
    teeForm.parentNode.insertBefore(upsellDiv, teeForm);

    function handleUpsell() {
      // Prepare form data
      const formUpsellProductData = {
        items: [
          {
            id: upsellCheckbox.dataset.productId, // Shopify variant/product ID
            quantity: productQuantityInput.value || 1,
          },
        ],
      };

      // Add to cart if upsell box is selected
      if (upsellCheckbox.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(formUpsellProductData),
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error('Error while updating upsell product:', error);
          });
      }
    }
    // });

    if (teeAtcButton) {
      teeAtcButton.addEventListener('click', handleUpsell);
    }

    if (teeBuyNowButton) {
      teeBuyNowButton.addEventListener('click', handleUpsell);
    }
  } else {
    console.warn('teeAtcButton not found after teeinblue injection.');
  }
});
